<div class="patient-files">
  <div class="patient-files__header">
    <div class="patient-files__title">{{ 'general.patientFiles' | translate }}</div>
    <div class="patient-files__description">{{ 'general.uploadUpperAndLowerPostOpScans' | translate }}</div>
  </div>

  <div class="patient-files__content">
    <wl-upload-scans
      *ngFor="let category of categories"
      [file]="fileConfigs[category]"
      [value]="filesByCategory[category]"
      [minBytes]="minBytes"
      (fileSelected)="fileSelected($event, category)"
      (cloudDriveEvent)="openCloudDrive(category)"
      (fileRemoved)="fileRemoved($event)"
    />
  </div>
</div>
